import useRoleContext from 'contexts/role.context';
import React from 'react';
import { Navigate } from 'react-router-dom';
import { MAIN_STORE_ROUTE_KEYS, STORAGE_KEYS } from 'utils/constants';
import { getTeamRoles } from 'utils/role-config';
import { getDefaultAuthorizedRoute } from 'utils/route-authorization';

const UnauthRoute = ({ children }: { children: JSX.Element }) => {
  const teamRoutes = getTeamRoles();
  const { role, permissions } = useRoleContext();
  const hasRoleId = Boolean(role?.id);
  const fallbackFromRole = role?.name ? teamRoutes?.[role.name]?.baseRoute ?? '' : '';
  const normalizedRoleFallback = fallbackFromRole.startsWith('/') ? fallbackFromRole : '';
  const hasPermissionPayload = permissions.length > 0;
  const fallback = hasPermissionPayload
    ? getDefaultAuthorizedRoute(permissions)
    : normalizedRoleFallback ||
      getDefaultAuthorizedRoute(permissions) ||
      MAIN_STORE_ROUTE_KEYS.GENERAL_STORE_DASHBOARD;
  const token: any = localStorage.getItem(STORAGE_KEYS.TOKEN);
  const hasAuthorizedSession = Boolean(token && hasRoleId);
  return !hasAuthorizedSession ? children : <Navigate to={fallback} />;
};
export default UnauthRoute;
